<template>
    <b-form-group :label="label">
        <b-form-checkbox
            switch
            v-model="data"
            :disabled="disabled"
            @change="$emit('change', $event)"
        />
    </b-form-group>
</template>

<script>
export default {
    name: 'FormSwitch',
    props: ['value', 'disabled', 'label'],
    computed: {
        data: {
            get: function() {
                return this.value
            },
            set: function(value) {
                this.$emit('update:value', value)
            },
        },
    },
}
</script>
